// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.native-sortable_06cdd853 {
  display: flex;
  width: fit-content;
}
.native-sortable_06cdd853 .native-sortable__item {
  cursor: move;
}
.native-sortable_06cdd853 .native-sortable__ghost {
  z-index: 1;
}
.native-sortable_06cdd853 .native-sortable__remove {
  position: fixed;
  top: 0;
  left: 0;
  will-change: transform;
  touch-action: none;
  z-index: 90;
}
.native-sortable_06cdd853 .native-sortable__remove::after {
  content: 'Remove';
  position: absolute;
  top: -3.833rem;
  left: 0;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,0.24), 0 0 2px 0 rgba(0,0,0,0.12);
  border: solid 0.084rem #dce1e5;
  border-radius: 0.333em;
  padding: 0.501rem 1.334rem;
  line-height: 1.715;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.native-sortable_06cdd853 .native-sortable__remove::after:has(a:focus-visible) {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.native-sortable_06cdd853 .native-sortable__remove::after:has(a:focus-visible) a:focus-visible {
  outline: none;
  box-shadow: none;
}
.native-sortable_drag-disabled_06cdd853 .native-sortable__item {
  cursor: unset;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"native-sortable": `native-sortable_06cdd853`,
	"native-sortable_drag-disabled": `native-sortable_drag-disabled_06cdd853`
};
export default ___CSS_LOADER_EXPORT___;
